import { Component, OnInit } from '@angular/core';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { Recurso, Processo, TipoRecurso } from '../../../../types/smartinteg';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-recurso-list',
  templateUrl: './recurso-list.component.html',
  styleUrls: ['./recurso-list.component.css'],
  providers: [ConfirmationService]
})
export class RecursoListComponent implements OnInit {

  recursos: Recurso[] = [];
  processos: Processo[] = [];
  tiposRecurso: any[];

  loading: boolean = true;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {
    this.tiposRecurso = Object.values(TipoRecurso).map(tipo => ({ label: tipo, value: tipo }));
  }

  ngOnInit(): void {
    this.carregarRecursos();
    this.carregarProcessos();
  }

  carregarRecursos(): void {
    this.loading = true;
    this.smartintegService.listarRecursos().subscribe({
      next: (data) => {
        this.recursos = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar recursos.');
        this.loading = false;
      }
    });
  }
  
  carregarProcessos(): void {
    this.smartintegService.listarProcessos().subscribe({
      next: (data) => this.processos = data
    });
  }

  deletarRecurso(recurso: Recurso): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar o recurso <strong>${recurso.nome}</strong>?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Lógica de deleção
      }
    });
  }
  
  onRowReorder(event: any): void {
    // Lógica para reordenar
    this.toastService.info('Info', 'Funcionalidade de reordenar a ser implementada.');
  }
  
  getIconeRecurso(tipo: TipoRecurso): string {
    switch (tipo) {
      case TipoRecurso.IMPORTACAO: return 'pi pi-cloud-download';
      case TipoRecurso.PROCESSAMENTO: return 'pi pi-cog';
      case TipoRecurso.VISUALIZACAO: return 'pi pi-eye';
      case TipoRecurso.EXPORTACAO: return 'pi pi-cloud-upload';
      case TipoRecurso.PUBLICACAO: return 'pi pi-globe';
      default: return 'pi pi-question';
    }
  }
}
